import http from "./http-common"; // Axios instance for API calls
import TrainingPeriod from "../types/TrainingPeriod"; // TrainingPeriod type definition
import { TrainingPeriodSummary } from "../types/TrainingPeriodSummary";
import  { SummaryDTO } from "../types/SummaryDTO"

class TrainingPeriodService {
  /**
   * Fetch all training periods for a user within a date range.
   * 
   * @param startDate - Start of the date range.
   * @param endDate - End of the date range.
   * @returns Array of TrainingPeriod.
   */
  async getByDateForRange(startDate: Date, endDate: Date): Promise<TrainingPeriod[]> {
    const response = await http.get("/training-periods", {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      },
    });
    return response.data as TrainingPeriod[];
  }

  /**
   * Fetch a single training period by its ID.
   * 
   * @param id - TrainingPeriod ID.
   * @returns TrainingPeriod data.
   */
  async getById(id: number): Promise<TrainingPeriod> {
    const response = await http.get(`/training-periods/${id}`);
    return response.data as TrainingPeriod;
  }

  /**
   * Add a new training period.
   * 
   * @param data - TrainingPeriod data to be created.
   * @returns Created TrainingPeriod.
   */
  async add(data: TrainingPeriod): Promise<TrainingPeriod> {
    const response = await http.post("/training-periods", data);
    return response.data as TrainingPeriod;
  }

  /**
   * Update an existing training period.
   * 
   * @param data - TrainingPeriod data with updates.
   * @returns Updated TrainingPeriod.
   */
  async update(data: TrainingPeriod): Promise<TrainingPeriod> {
    const response = await http.put(`/training-periods/${data.id}`, data);
    return response.data as TrainingPeriod;
  }

  /**
   * Delete a training period by its ID.
   * 
   * @param id - TrainingPeriod ID.
   * @returns ID of the deleted TrainingPeriod.
   */
  async deleteById(id: number): Promise<number> {
    await http.delete(`/training-periods/${id}`);
    return id;
  }



  async getSummary(periodId: number): Promise<SummaryDTO> {
    const response = await http.get(`/training-periods/${periodId}/summary`);
    return response.data as SummaryDTO;
  }
}

const trainingPeriodService = new TrainingPeriodService();
export default trainingPeriodService;
